<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label>Ragione sociale <span class="text-danger" v-if="showAsterisks">*</span></label>
                <input type="text" class="form-control" v-model="localValue.companyName" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Partita IVA <span class="text-danger" v-if="showAsterisks">*</span></label>
                <input type="text" class="form-control" v-model="localValue.vatNumber" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Codice SDI</label>
                <input type="text" class="form-control" v-model="localValue.sdiCode" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>PEC</label>
                <input type="text" class="form-control" v-model="localValue.pec" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Email</label>
                <input type="text" class="form-control" v-model="localValue.email" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Telefono</label>
                <input type="text" class="form-control" v-model="localValue.telephone" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as CONST from '@/const';
import { mixins, Options, Vue } from 'vue-class-component';
import store from '@/store';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class billingInfo extends mixins(WithModel) {

    declare localValue: OM.BillingInfo;

    @Prop({
        default: false
    }) showAsterisks: boolean;

    // get pivaError(){
    //     if(!this.localValue.vatNumber.trim()){
    //         return false;
    //     }

    //     if(this.localValue.vatNumber.length != 11){
    //         return true;
    //     }
    // }

}

</script>
